// org 설정(orgs/{orgId}) 실시간 구독 스토어 — 창고 좌표·권역 설정을 앱 전역에 공급(전국화 기반)
import { create } from "zustand";
import { doc, onSnapshot, type Unsubscribe } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { setRegionConfig } from "@/lib/region";
import type { Org } from "@/types";

interface OrgState {
  org: Org | null;
}

export const useOrgStore = create<OrgState>(() => ({ org: null }));

let unsub: Unsubscribe | null = null;

/** 로그인 직후(auth 스토어) 호출 — org 문서 구독 + 권역 설정 반영 */
export function subscribeOrg(orgId: string) {
  unsubscribeOrg();
  unsub = onSnapshot(
    doc(db, "orgs", orgId),
    (snap) => {
      const org = snap.exists() ? ({ id: snap.id, ...(snap.data() as any) } as Org) : null;
      useOrgStore.setState({ org });
      // 권역 설정: org.regions[0]=시도, org.sigungu=시군구 목록 (없으면 부산 기본값 로직은 region.ts가 처리)
      setRegionConfig(org?.regions?.[0] ? { sido: org.regions[0], sigungu: org.sigungu } : null);
    },
    () => {
      // 권한 없음 등 — 폴백 유지(org 없이도 앱은 기본값으로 동작)
      useOrgStore.setState({ org: null });
      setRegionConfig(null);
    },
  );
}

export function unsubscribeOrg() {
  if (unsub) { unsub(); unsub = null; }
  useOrgStore.setState({ org: null });
  setRegionConfig(null);
}
